const getPlayerHeadshot = player => {
  return process.env.REACT_APP_YES_ASSETS + '/player-headshot/' + player.player_id + '.png';
};

export default getPlayerHeadshot;
